import React, { Component } from 'react';
import styles from './contentContainer.css';

export default class ContentContainer extends Component {
  render() {
    return (<div className={styles.container}>
      {this.props.children}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/contentContainer/contentContainer.jsx